export default __webpack_public_path__ + "static/media/what_we_do_3.420d9dea.svg";